<div class="modal-container">
  <div mat-dialog-title class="display-flex modal-header">
    <div class="subtitle mr-4 display-flex align-items-center">
      <span class="mr-4">{{ data.editMode ? 'Edit ' : 'Add ' }}</span>
      <div
        class="mr-4"
        [appFadeTextOnWidth]="335"
        [titleLength]="data.templateTitle?.length"
        [matTooltip]="data.templateTitle">
        {{ data.templateTitle }}
      </div>
      <span>{{ ' Description' }}</span>
    </div>
  </div>

  <mat-dialog-content>
    <div class="comment-container">
      <span class="title">Description</span>
      <textarea
        [formControl]="descriptionControl"
        aria-label="comment-area"
        autofocus
        class="comment-area"
        [attr.maxlength]="maxLength"
        rows="50"
        placeholder="A really thoughtful description that you haven't thought about yet..."></textarea>
      <div class="count">[{{ descriptionControl?.value?.length }}/{{ maxLength }}]</div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <button mat-stroked-button color="warn" mat-dialog-close>Cancel</button>
    <button mat-raised-button type="button" color="primary" (click)="onSave()">Save</button>
  </mat-dialog-actions>
</div>
